<template>
  <div class="demographicGender">
    <adx-list-item :data='data' :type="`bar`" />
  </div>
</template>

<script>
import ListItem from '@/components/ListDemographic'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-campaignreport-demographic-gender',
  components: {
    'adx-list-item': ListItem
  },
  props: {

  },
  data() {
    return {
      data: {
        header: ['GENDER', 'USER'],
        body: []
      }
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {
    this.loadData()
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async loadData() {
      const { status, data } = await api.get(apiV2.measurementcampaignReportDetail(this.$route.params.campaign_id), { needToken: true })
      if(status == 200) {
        let { demographic_gender } = await data
        // demographic_gender = {
        //   "male" : 0.4,
        //   "female" : 0.6

        // }
        let {total_traffic} = await data
        // console.log("gender", status, data, total_traffic)
        this.data.body = Object.keys(demographic_gender).map((key, index) => {
          return {
            'demographic_gender': key,
            'user': demographic_gender[key],
            'total': Math.round(demographic_gender[key] * total_traffic /100),
          }
        });
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>